<template>
  <v-chip close class="mr-2 mt-2 pb-6 pt-6" @click:close="onRemove">
    <div>
      {{ labelCodigoInterno }} {{ fornecedor.pessoa.nome | truncate(15) }}
      <div>
        <small> {{ fornecedor.pessoa.cnpj | cnpj }} </small>
      </div>
    </div>
  </v-chip>
</template>
<script>
export default {
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    labelCodigoInterno() {
      return this.fornecedor.codigoInterno ? `${this.fornecedor.codigoInterno} -` : '';
    },
  },
  methods: {
    onRemove() {
      this.$emit('remove', this.fornecedor);
    },
  },
};
</script>
